import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🌐 Environment Variables

Environment variables (Env Variables) are user-defined key-value pairs scoped at the **workspace level**. This means they are accessible across **all collections and requests** within a single workspace.

They are particularly useful for managing different values based on environments like **development, staging, or production**. For example, your API base URL or authorization token might vary across environments — environment variables make it easy to switch between them without editing each request manually.

You can refer to these variables using the double curly braces syntax: **{{baseUrl}}**. This allows you to write reusable and dynamic requests.

**Example use case:**  
If your development API base URL is **https://dev.api.example.com**, and production is **https://api.example.com**, you can define **baseUrl** for each environment separately. Your request can just use **{{baseUrl}}/users** and it will dynamically resolve depending on the selected environment.

Environment variables are stored under the **workspace** folder inside a **variables** directory. Each environment has its own file for easy Git tracking, version control, and offline access.

HawkClient allows you to switch environments easily from the workspace UI. Only one environment can be active at a time — and the active environment's variables will automatically be injected into all requests.

---

![Environment Variables](/docs/envVariables.png)

## 🔄 Variable Precedence

Variable precedence helps determine which value is used when duplicate variable keys exist across scopes. In HawkClient, the order of precedence is:

1. **Request Variables** – highest priority
2. **Environment Variables**
3. **Collection Variables**
4. **Global Variables** – lowest priority

This means if **baseUrl** is defined both in the collection and the active environment, the value from the environment will be used. However, if a request explicitly defines **baseUrl**, it will override everything else.

To manage environments more efficiently, HawkClient provides a clean UI for creating, editing, duplicating, and switching environments — no login or cloud sync is required.
`;

const EnvVariables = () => {
    return (
        <MarkDownRenderer
            title="Environment Variables"
            markDownText={markdownContent}
        />
    );
};

export default EnvVariables;
